// import bollingerBandsRegistry from './bollingerBandsRegistry';
import movingAveragesRegistry from "./movingAveragesRegistry";
import trendRegistry from "./trendRegistry";
import oscillatorsRegistry from "./oscillatorsRegistry";
import volumeRegistry from "./volumeRegistry";
import momentumRegistry from "./momentumRegistry";
import volatilityRegistry from "./volatilityRegistry";

const indicatorRegistry = {
  // bollingerBands: bollingerBandsRegistry,
  movingAverages: movingAveragesRegistry,
  trend: trendRegistry,
  oscillators: oscillatorsRegistry,
  volume: volumeRegistry,
  momentum: momentumRegistry,
  volatility: volatilityRegistry,
};

export default indicatorRegistry;
